import { Router, CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { DataService } from '../../user-detail.service';
import { LoginService } from './login.service';
import { Staff } from '../../models/staff';

@Injectable()
export class AuthGuard implements CanActivate {
    user: Staff;
    // authURL = `${Globals.AUTH_URL}/home?action=issue&redirectUrl=${Globals.REDIRECT_URL}&appName=attendancePc`;

    constructor(
        private router: Router,
        private loginService: LoginService,
        private dataService: DataService
    ) { 
        this.user = this.dataService.getStaffInformation;
    }

    canActivate(): boolean | Observable<boolean> {
        const token = localStorage.getItem('access_token');

        if(!token) {
        // request token from login system via iframe
        this.loginService.requestToken();

        // subscribe for the reply token from login system
        return this.loginService.tokenSubject.pipe(
            map (
            () => {
                return true;
            }
            )
        )
        } 

        // If token exists, validate it
        return this.loginService.validateToken().pipe(
            switchMap(res => {
                if (!res.data) {
                    if (res.message == '403') { // access denied
                        this.router.navigate(['/unauthorized']);
                    } else {
                        this.loginService.requestToken();

                        // subscribe for the reply token from login system
                        return this.loginService.tokenSubject.pipe(
                            map (
                            () => {
                                return true;
                            }
                            )
                        )
                    }
                } else {
                    return of(true);
                }
            })
        )
    }

}
